import directApi from "./direct-api";
import mockedApi from "./mocked-api";

let api = directApi;

export default api;
